<template>
  <v-card flat class="overflow-hidden bc-card">
    <!-- HEADER -->
    <v-toolbar flat height="56" style="background-color:#37474f !important" dark>
      <v-icon class="mr-3">mdi-account-search-outline</v-icon>
      <v-toolbar-title class="font-weight-black text-uppercase" style="letter-spacing:1px;font-size:0.9rem">
        Seleccionar Cliente
      </v-toolbar-title>
      <div class="ml-3 caption" style="opacity:0.7">Busca y selecciona un cliente</div>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card-text class="pa-6">
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Buscar por nombre, código o identificación..."
        outlined
        dense
        class="mb-4 bc-search"
        hide-details
      ></v-text-field>

      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        class="bc-table clickable-rows"
        :loading="loading"
        :items-per-page="8"
        @click:row="handleRowClick"
      >
        <template v-slot:[`item.codigo`]="{ item }">
          <span class="font-weight-bold" style="color:#37474f">{{ item.codigo }}</span>
        </template>
        
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            small
            style="background-color:#37474f !important;border-radius:4px"
            dark
            depressed
            class="px-4 font-weight-bold"
            @click.stop="handleRowClick(item)"
          >
            Seleccionar
          </v-btn>
        </template>

        <template v-slot:no-data>
          <div class="pa-10 text-center grey--text">
            <v-icon size="48" color="grey lighten-2">mdi-account-off-outline</v-icon>
            <p class="mt-2 text-body-2">No se encontraron clientes</p>
          </div>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";

export default {
  props: {
    allwedOnly: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      search: "",
      loading: false,
      headers: [
        { text: "Código", align: "start", value: "codigo", width: 120 },
        { text: "Nombre / Razón Social", align: "start", value: "nombre" },
        { text: "ID / Cédula", align: "start", value: "cedula", width: 140 },
        { text: "Acciones", value: "actions", sortable: false, align: "right", width: 130 },
      ],
      items: [],
    };
  },

  computed: {
    ...mapGetters(["strCia"]),
  },

  created() {
    this.getData();
  },

  methods: {
    getData() {
      const me = this;
      me.loading = true;
      axios
        .get("api/Clientes/getClientesByCompany?cia=" + this.strCia)
        .then(response => {
          me.items = response.data;
        })
        .finally(() => {
          me.loading = false;
        });
    },

    handleRowClick(item) {
      this.$emit("clicked", Object.assign({}, item));
    },

    close() {
      this.$emit("closed");
    },
  },
};
</script>

<style scoped>
/* === BC DESIGN SYSTEM (BuscarClientes) === */
.bc-card {
  border-radius: 4px !important;
  background: #ffffff !important;
}
.theme--dark .bc-card {
  background: #1e293b !important;
}

/* Search input cuadrado */
.bc-search >>> .v-input__slot {
  border-radius: 4px !important;
}

/* Tabla */
.bc-table >>> thead th {
  background-color: #37474f !important;
  color: #ffffff !important;
  text-transform: uppercase;
  font-size: 0.68rem !important;
  font-weight: 700 !important;
  border-bottom: none !important;
  letter-spacing: 0.06em;
}
.theme--dark .bc-table >>> thead th {
  background-color: #263238 !important;
  color: #cfd8dc !important;
}
.bc-table >>> tbody tr:hover {
  background-color: rgba(55, 71, 79, 0.06) !important;
}

/* Filas clicables */
.clickable-rows >>> tbody tr {
  cursor: pointer;
}
</style>